// findRequestInList
// -----------------
// Pure lookup shared by the Responders Task List and the Pickers list when a
// task is opened: find the already-loaded request by id, but if that id row is a
// Draft and a refNo was supplied, prefer the refNo match; finally fall back to a
// refNo match when the id isn't found. Extracted verbatim from the two identical
// onViewRequest handlers in portal.jsx so the logic is shared + unit-tested.
//
// TypeScript source -- findRequestInList.js is a thin re-export stub.

import { REQUEST_STATUSES } from "./enums";

export interface RequestLike {
  id?: unknown;
  refNo?: unknown;
  ref_no?: unknown;
  status?: string | null;
}

export function findRequestInList<T extends RequestLike>(
  requests: T[],
  reqId: unknown,
  refNo: unknown
): T | undefined {
  let found = requests.find((r) => r.id === reqId);
  // If the id matched a Draft but a refNo was supplied, prefer the refNo row.
  if (found && found.status === REQUEST_STATUSES.DRAFT && refNo) {
    const byRef = requests.find((r) => r.refNo === refNo || r.ref_no === refNo);
    if (byRef) found = byRef;
  }
  if (!found && refNo) {
    found = requests.find((r) => r.refNo === refNo || r.ref_no === refNo);
  }
  return found;
}
